export default __webpack_public_path__ + "static/media/vaccines_light.a13d0b1e.jpeg";